var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"table_store":"call-tracking/numbers/table"},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('table-control',{attrs:{"type":"trash"},on:{"click":function($event){return _vm.remove(item)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }